import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AssociatedBuilders from '../views/AssociatedBuilders.vue';
import BuyerView from '../views/BuyerView.vue';
import AboutView from '../views/AboutView.vue';
import ContactView from '../views/ContactView.vue';
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/associatedbuilders',
    name: 'associatedbuilders',
    component: AssociatedBuilders,
  },
  {
    path: '/buyer',
    name: 'buyer',

    component: BuyerView,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: ContactView,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
